import { useMutation, useQueryClient } from "react-query";
import { GET_COLLABORATION_NOTES } from "@constants/reactQueryKeys";
import { createCollaborationNote } from "api/collaborationNotes";
import { useGlobalToast } from "components/GlobalToastProvider";

/**
 * Mutation hook for creating a new collaboration note. Invalidates the notes
 * query on success so the drawer refreshes automatically.
 */
const useCreateCollaborationNote = () => {
  const queryClient = useQueryClient();
  const { showToast } = useGlobalToast();

  const { mutateAsync, isLoading } = useMutation(
    ({
      clientId,
      providerId,
      body,
    }: {
      clientId: string;
      providerId: string;
      body: string;
    }) => createCollaborationNote(clientId, providerId, { body }),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries([
          GET_COLLABORATION_NOTES,
          variables.clientId,
          variables.providerId,
        ]);
        showToast({ message: "Collaboration note saved" });
      },
      onError: () => {
        showToast({
          message: "Failed to save collaboration note",
          errorState: true,
        });
      },
    },
  );

  return { createNote: mutateAsync, isCreating: isLoading };
};

export default useCreateCollaborationNote;
